<odx-form-field i18n-label="@@newProject.projectForm.label.locationName" label="Ortsbezeichnung" [readonly]="!isWriteable()">
  <input
    formControlName="placeName"
    odxFormFieldControl
    i18n-placeholder="@@newProject.projectForm.placeholder.locationName"
    placeholder="Ortsbezeichnung"
    [readonly]="isReadonly"
    data-testid="projectForm.location"
  />
</odx-form-field>
